import React from 'react';
import { Button, Form, Input, Modal, Tag } from 'antd';
import { ProductSelectItem } from './product-select-modal';

const { TextArea } = Input;

type DimType = 'SPU' | 'SKU';

type BanOnAddModalProps = {
    dim: DimType;
    visible: boolean;
    selectedItems: ProductSelectItem[];
    remark: string;
    errors: { code: string; remark: string };
    confirmLoading?: boolean;
    title?: string;
    onCancel: () => void;
    onOk: () => void;
    onOpenSelect: () => void;
    onRemoveSelected: (code: string) => void;
    onRemarkChange: (value: string) => void;
};

export const BanOnAddModal = ({
    dim,
    visible,
    selectedItems,
    remark,
    errors,
    confirmLoading,
    title = '添加禁止上架名单',
    onCancel,
    onOk,
    onOpenSelect,
    onRemoveSelected,
    onRemarkChange,
}: BanOnAddModalProps) => {
    return (
        <Modal
            title={title}
            visible={visible}
            onCancel={onCancel}
            onOk={onOk}
            confirmLoading={confirmLoading}
            destroyOnClose
            width={640}
            wrapClassName="shelf-rule-add-modal"
            okText="确定"
            cancelText="取消"
        >
            <Form layout="horizontal" labelCol={{ span: 5 }} wrapperCol={{ span: 18 }}>
                <Form.Item
                    label={`${dim}编码`}
                    required
                    validateStatus={errors.code ? 'error' : ''}
                    help={errors.code || undefined}
                >
                    <Button onClick={onOpenSelect}>选择 {dim}</Button>
                    {selectedItems.length > 0 ? (
                        <div className="shelf-rule__selected-tags">
                            {selectedItems.map((item) => (
                                <Tag
                                    key={item.code}
                                    closable
                                    onClose={() => onRemoveSelected(item.code)}
                                >
                                    {item.code}
                                </Tag>
                            ))}
                        </div>
                    ) : (
                        !errors.code && (
                            <div className="shelf-rule__select-hint">请选择一个或多个 {dim}</div>
                        )
                    )}
                </Form.Item>
                <Form.Item
                    label="说明"
                    required
                    validateStatus={errors.remark ? 'error' : ''}
                    help={errors.remark || undefined}
                >
                    <div className="shelf-rule__remark">
                        <TextArea
                            rows={4}
                            maxLength={200}
                            placeholder="请填写加入名单的原因（必填）"
                            value={remark}
                            onChange={(e) => onRemarkChange(e.target.value.slice(0, 200))}
                        />
                        <div className="shelf-rule__remark-count">{remark.length} / 200</div>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};
